import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67317a9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "current__locale__text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M17 10L15.2527 11.763C13.8592 13.1689 13.1625 13.8719 12.3133 13.9801C12.1053 14.0066 11.8947 14.0066 11.6867 13.9801C10.8375 13.8719 10.1408 13.1689 8.74731 11.763L7 10",
  stroke: "white",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "locale__list flex direction-column align-center"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "locale__list__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: "current__locale flex align-center",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isOpen = !_ctx.isOpen), ["stop"]))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.locales[_ctx.locale]), 1),
    (_openBlock(), _createElementBlock("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: _normalizeClass({ active: _ctx.isOpen })
    }, _hoisted_3, 2)),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLocaleList, (value, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["locale__list__locale", { active: key === _ctx.locale }]),
                  key: key,
                  onClick: ($event: any) => (_ctx.locale = value[0])
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(value[1]), 1)
                ], 10, _hoisted_5))
              }), 128))
            ])), [
              [_directive_click_outside, _ctx.closeLocaleList, 300]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}